"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSelectCarModelList = void 0;
var react_1 = __importDefault(require("react"));
var ModalSelectList_module_scss_1 = __importDefault(require("./ModalSelectList.module.scss"));
var selectors_1 = require("../../redux/selectors");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var react_redux_1 = require("react-redux");
var ModalSelectCarModelList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var setModelFilter = function (configValue) {
        dispatch((0, modalSlice_1.setFilterModel)(configValue));
    };
    var filterList = (0, react_redux_1.useSelector)(selectors_1.modalSelector).selectCar.filter.model.thisValue;
    return (react_1.default.createElement("ul", { className: ModalSelectList_module_scss_1.default.modal_select__list }, filterList.map(function (item) {
        var filter = item;
        return (react_1.default.createElement("li", { className: ModalSelectList_module_scss_1.default.modal_select__item, key: filter.name, onClick: function () {
                return setModelFilter({
                    nextValue: filter.generations,
                    thisValue: filterList,
                    status: true,
                    selected: filter.name,
                });
            } },
            filter.name,
            " ",
            react_1.default.createElement("span", null, filter.total)));
    })));
};
exports.ModalSelectCarModelList = ModalSelectCarModelList;
